import React from 'react';


const DashboardMetricCard = ({
    title,
    value,
    icon: Icon,
    className = '',
    valueClassName = '',
    titleClassName = '',
    iconClassName = ''
}) => {
    return (
        <div className={`bg-grayBgNormal rounded-lg p-5 shadow-sm border border-borderUnderline ${className}`}>
            <div className="flex items-center justify-between">
                <div className="flex-1">
                <p className={`text-sm text-textSecondary mb-[.375rem] font-medium ${titleClassName}`}>
                        {title}
                </p>
                <div className={`text-3xl font-medium  leading-8 ${valueClassName}`}>
                    {Icon && (
                <div className={`  ${iconClassName}`}>
                        <Icon className="w-6 h-6 text-blue-600" />
                </div>
                )}
                <p className='text-textPrimary'>
                { value}
                </p>
                    
                    </div>
                   
                </div>
             
            </div>
        </div>
    );
};

export default DashboardMetricCard; 